const body = document.querySelector('body');

let header = document.querySelector(
  '#header, #shopify-section-main-password-header header'
);
let announcementBar = document.querySelector('.js-announcement-bar');

let productMedia = document.querySelector('.product__media'); // on pdp
let productMediaSwiper = document.querySelector('.product__media .swiper'); // on pdp

const mobileMediumWidth = 575;
const mobileWidth = 750;
const tabletWidth = 990;
const windowDynamicEvents = ['scroll', 'resize'];

/* this script is breaking responsivity and demo store - rethink it
// maybe we can add an option to activate this script

// is mobile is true, remove all elements has class 'small-hide'
if (window.innerWidth <= mobileWidth) {
  document.querySelectorAll('.small-hide').forEach(function (el) {
    el.remove();
  });
} else {
  document.querySelectorAll('.small-up-hide').forEach(function (el) {
    el.remove();
  });
}
*/

// add loading lazy attribute to div.hero__inner > div.media > video > img
document.querySelectorAll('.hero__inner > .media > video > img').forEach(function (el) {
  el.setAttribute('loading', 'lazy');
  el.setAttribute('alt', 'Video Cover');
});

// catch all images with class 'lazyload' and add loading lazy attribute
document.querySelectorAll('.lazyload').forEach(function (el) {
  el.setAttribute('loading', 'lazy');
});

// check browser lazyload support
if ('loading' in HTMLImageElement.prototype) {
  // console.log('Browser support lazyload');
  // add loading lazy attribute to all images with class 'lazyload'
  document.querySelectorAll('.lazyload').forEach(function (el) {
    el.setAttribute('loading', 'lazy');
  });
} else {
  // console.log('Browser not support lazyload');
}

windowDynamicEvents.forEach(eventType => {
  window.addEventListener(eventType, () => {
    setRootCustomProperties();
  });
});

setRootCustomProperties();

document.addEventListener('shopify:section:load', function () {
  header = document.querySelector(
    '#header, #shopify-section-main-password-header header'
  );
  announcementBar = document.querySelector('.js-announcement-bar');



  setRootCustomProperties();
});


function setRootCustomProperties() {

  const setCustomProperty = (property, value) => {
    document.documentElement.style.setProperty(property, value);
  };

  // viewport height
  setCustomProperty('--viewport-height', `${window.innerHeight}px`);

  // header height + top offset for fixed mega menu / overlays
  // settings.liquid uses calc(header-height + announcement-height); that drifts on scroll when the
  // announcement bar moves or sticky stacking changes. Use live viewport bottom of #header instead.
  if (header) {
    setCustomProperty('--header-height', `${parseInt(header.offsetHeight)}px`);
    let headerBottom = header.getBoundingClientRect().bottom;
    // Sticky desktop mega: align panel to inner content edge, not below .header__inner
    // bottom padding (avoids a dead strip between nav and mega when the header is sticky).
    if (
      header.classList.contains('is-sticky') &&
      window.innerWidth >= tabletWidth
    ) {
      const headerInner = header.querySelector('.header__inner');
      if (headerInner) {
        const padBottom = parseFloat(getComputedStyle(headerInner).paddingBottom) || 0;
        if (padBottom > 0) {
          headerBottom -= padBottom;
        }
      }
    }
    setCustomProperty(
      '--header-top-position',
      `${Math.max(0, Math.ceil(headerBottom))}px`
    );
  } else {
    setCustomProperty('--header-height', `0px`);
    setCustomProperty('--header-top-position', `0px`);
  }

  // section body width
  const sectionBody = document.querySelector('section > .container > .section__body');
  if (sectionBody) {
    setCustomProperty('--section-body-width', `${parseInt(sectionBody.offsetWidth)}px`);
  }

  // announcement bar top
  if (announcementBar) {
    let announcementBarTop = Math.max(0, announcementBar.getBoundingClientRect().y + announcementBar.offsetHeight);
    setCustomProperty('--announcement-bar-top', `${parseInt(announcementBarTop)}px`);
    setCustomProperty('--announcement-bar-height', `${parseInt(announcementBar.offsetHeight)}px`);
  } else {
    setCustomProperty('--announcement-bar-top', `0px`);
    setCustomProperty('--announcement-bar-height', `0px`);
  }

  // product media width
  if (productMedia) {
    setCustomProperty('--product-media-area-width', `${parseInt(productMedia.offsetWidth)}px`);
    setCustomProperty('--product-media-area-swiper-height', `${parseInt(productMediaSwiper.offsetHeight)}px`);
  }

  // transparent header menu color
  // get data-header-menu-text-color of first .hero__inner under .hero-banner element
  let heroBanner = document.querySelector('.hero-banner, .hero-banner-tabs');
  if (heroBanner) {
    let heroInner = heroBanner.querySelectorAll('.hero__inner');
    if (heroInner.length > 0) {
      let heroInnerFirst = heroInner[0];
      let headerMenuTextColor = heroInnerFirst.getAttribute('data-header-menu-text-color');
      if (headerMenuTextColor) {
        setCustomProperty('--transparent-header-menu-text-color', `${headerMenuTextColor}`);
      }
    }
  } else {
    setCustomProperty('--transparent-header-menu-text-color', `var(--color-link-text-inverse)`);
  }

}


const bodyScroll = {
  lock(container) {
    bodyScrollLock.disableBodyScroll(container);
  },
  unlock(container) {
    bodyScrollLock.enableBodyScroll(container);
  },
  clear() {
    bodyScrollLock.clearAllBodyScrollLocks();
  }
};

const onKeyUpEscape = event => {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus({
    preventScroll: true
  });
};

const getFocusableElements = container => {
  return Array.from(
    container.querySelectorAll(
      'summary, a[href], button:enabled, [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'
    )
  );
};

document
  .querySelectorAll('[id^="Details-"] summary')
  .forEach(summary => {
    summary.setAttribute('role', 'button');
    summary.setAttribute(
      'aria-expanded',
      summary.parentNode.hasAttribute('open')
    );

    if (summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute(
        'aria-controls',
        summary.nextElementSibling.id
      );
    }

    summary.addEventListener('click', event => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });

const trapFocusHandlers = {};

const removeTrapFocus = (elementToFocus = null) => {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener(
    'focusout',
    trapFocusHandlers.focusout
  );
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus)
    elementToFocus.focus({
      preventScroll: true
    });
};

const trapFocus = (container, elementToFocus = container) => {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener(
      'keydown',
      trapFocusHandlers.keydown
    );
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
};

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

const deepClone = obj => {
  return JSON.parse(JSON.stringify(obj));
};

const handleize = str => str.replace(/[ /_]/g, '-').toLowerCase();

const decode = str => decodeURIComponent(str).replace(/\+/g, ' ');

const getOffsetTop = element => {
  let offsetTop = 0;

  do {
    if (!isNaN(element.offsetTop)) {
      offsetTop += element.offsetTop;
    }
  } while ((element = element.offsetParent));

  return offsetTop;
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.drawer = this.querySelector('.js-drawer');
    this.btnsCloseDrawer = this.querySelectorAll(
      '.js-btn-close-drawer'
    );
    this.btnsCloseDrawer = [...this.btnsCloseDrawer].filter(
      btnCloseDrawer =>
        this.drawer === btnCloseDrawer.closest('.js-drawer')
    );
    this.elementToFocus =
      this.querySelector('.js-drawer-focus-element') ||
      this.btnsCloseDrawer[0];
    this.toggleButtons = [this.summary, ...this.btnsCloseDrawer];
    this.isParentDrawerOpen = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    // Ensure drawer starts in a consistent state BEFORE setting accessibility attributes
    // If details has 'open' attribute but no 'menu-opening' class, remove the attribute
    // This fixes the issue on cart page where open attribute is set but drawer isn't actually open
    if (this.details && this.details.hasAttribute('open') && 
        !this.details.classList.contains('menu-opening')) {
      this.details.removeAttribute('open');
      this.toggleButtons.forEach(toggleButton => {
        toggleButton.classList.remove('menu-is-open');
        toggleButton.setAttribute('aria-expanded', false);
      });
    }

    this.setInitialAccessibilityAttr();

    this.toggleButtons.forEach(toggleButton => {
      toggleButton.addEventListener('click', e => {
        e.preventDefault();

        this.toggleDrawer();
      });
    });

    this.addEventListener('keydown', e => {
      const isEscapeKey = e.key === 'Escape';
      const isDrawerOpen =
        this.details.classList.contains('menu-opening');
      const nestedOpenDrawer =
        this.details.querySelector('details[open]');

      if (!isEscapeKey || nestedOpenDrawer || !isDrawerOpen) {
        return;
      }

      if (
        this.predictiveSearch &&
        this.predictiveSearch.input == document.activeElement
      ) {
        return;
      }

      this.toggleDrawer();
    });

    this.toggleTrapFocus();
  }

  isDrawerOpen() {
    return (
      this.details.hasAttribute('open') &&
      this.details.classList.contains('menu-opening')
    );
  }

  closeDrawer() {
    if (!this.isDrawerOpen()) {
      return;
    }

    this.toggleDrawer();
  }

  closeOtherMobileHeaderDrawers() {
    if (window.innerWidth >= tabletWidth) {
      return;
    }

    const drawerPairs = [
      ['header-drawer', '#Navigation-drawer-header'],
      ['desktop-drawer', '#Search-drawer-header']
    ];

    drawerPairs.forEach(([tagName, detailsSelector]) => {
      const details = document.querySelector(detailsSelector);

      if (!details) {
        return;
      }

      const drawerEl = details.closest(tagName);

      if (!drawerEl || drawerEl === this || !drawerEl.isDrawerOpen()) {
        return;
      }

      drawerEl.closeDrawer();
    });
  }

  toggleDrawer() {
    const isDrawerTransitioning = this.details.classList.contains('drawer-transitioning');

    /* diginote: buggy code
    if (isDrawerTransitioning) {
      return;
    }
    */

    /* diginote: not needed code
    this.drawer.addEventListener(
      'transitionstart',
      e => {
        this.details.classList.add('drawer-transitioning');
      },
      { once: true }
    );
    */

    // Check both the attribute and class to determine if drawer is truly open
    // This ensures consistency even if the attribute is set without the class
    const isDetailsOpen = this.details.hasAttribute('open') && 
                          this.details.classList.contains('menu-opening');

    if (!isDetailsOpen) {
      this.closeOtherMobileHeaderDrawers();

      this.details.setAttribute('open', '');
      this.toggleButtons.forEach(toggleButton => {
        toggleButton.classList.add('menu-is-open');
        toggleButton.setAttribute('aria-expanded', true);
      });
      this.details.classList.add('menu-opening');

      const bodyHasOverflow = body.style.overflow === 'hidden';
      if (bodyHasOverflow) {
        this.parentDrawer = this.closest('.js-drawer');
        if (!this.parentDrawer) {
          this.isParentDrawerOpen = false;
        }
        this.isParentDrawerOpen = true;
        this.parentDrawer.style.overflow = 'hidden';
      } else {
        body.style.overflow = 'hidden';
      }
    } else {
      this.details.removeAttribute('open');
      this.details.classList.remove('menu-opening');
      this.toggleButtons.forEach(toggleButton => {
        toggleButton.classList.remove('menu-is-open');
        toggleButton.setAttribute('aria-expanded', false);
      });
      body.style.overflow = '';

      if (this.isParentDrawerOpen) {
        this.parentDrawer.style.overflow = '';
      }
    }

    const handleDropdownTransition = e => {
      if (e.target !== this.drawer || e.propertyName !== 'visibility') {
        return;
      }

      this.details.classList.remove('drawer-transitioning');

      if(this.elementToFocus) {
        this.elementToFocus.focus({
          preventScroll: true
        });
      }

      const isDetailsOpen = this.details.hasAttribute('open');

      if (!isDetailsOpen) {
        this.toggleButtons.forEach(toggleButton => {
          toggleButton.setAttribute('aria-expanded', false);
        });
        this.summary.focus({
          preventScroll: true
        });
      }

      if (this.isParentDrawerOpen) {
        this.parentDrawer.style.overflow = '';
        document.body.style.overflow = '';
      } else {
        document.body.style.overflow = 'hidden';
      }

      e.target.removeEventListener('transitionend', handleDropdownTransition);
    };

    this.drawer.addEventListener('transitionstart', e => {
      this.details.classList.add('drawer-transitioning');
    }, {
      once: true
    });

    this.drawer.addEventListener('transitionend', handleDropdownTransition);
  }

  instantlyHideDrawer() {
    this.toggleButtons.forEach(toggleButton => {
      toggleButton.setAttribute('aria-expanded', false);
    });
    this.details.classList.remove('menu-opening');
    this.details.removeAttribute('open');
    body.style.overflow = '';
  }

  toggleTrapFocus(container = this.drawer) {
    document.addEventListener('focusin', e => {
      const isDrawerOpen =
        this.details.classList.contains('menu-opening');

      if (!isDrawerOpen) {
        return;
      }

      const openDrawer = e.target.closest(
        'details.menu-opening .js-drawer'
      );
      const nestedOpenDrawer = this.details.querySelector(
        'details.menu-opening'
      );

      if (openDrawer === this.drawer || nestedOpenDrawer) {
        return;
      }

      e.preventDefault();

      const focusableElements = getFocusableElements(container);
      const focusedElementDOMPosition =
        container.compareDocumentPosition(e.target);

      const visibleFocusableElements = focusableElements.filter(
        focusableElement => {
          const isHidden =
            getComputedStyle(focusableElement).display === 'none';

          if (isHidden) {
            return;
          }

          const isSummary = focusableElement.tagName === 'SUMMARY';
          const focusableElementDetails =
            focusableElement.closest('details');
          const parentFocusableElementDetails =
            focusableElementDetails.parentElement.closest('details');
          const focusableElementDrawer =
            focusableElementDetails.querySelector('.js-drawer');
          const isThisDrawerOrDetails = focusableElementDrawer
            ? focusableElementDrawer === this.drawer
            : focusableElementDetails === this.details;

          return (
            isThisDrawerOrDetails ||
            (isSummary &&
              parentFocusableElementDetails.hasAttribute('open'))
          );
        }
      );

      const firstFocusableElement = visibleFocusableElements[0];
      const lastFocusableElement =
        visibleFocusableElements[visibleFocusableElements.length - 1];

      if (focusedElementDOMPosition >= 4) {
        firstFocusableElement.focus({
          preventScroll: true
        });

        return;
      }

      lastFocusableElement.focus({
        preventScroll: true
      });
    });
  }

  setInitialAccessibilityAttr() {
    const isDetailsOpen = this.details.hasAttribute('open');

    this.summary.setAttribute('role', 'button');
    this.summary.setAttribute('aria-controls', this.drawer.id);
    this.summary.setAttribute('aria-expanded', isDetailsOpen);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    window.addEventListener('resize', e => {
      const isMobileDrawer = this.classList.contains('mobile-drawer');

      if (!isMobileDrawer) {
        return;
      }

      const isDesktop = window.innerWidth < tabletWidth;
      const isMenuOpen =
        this.details.classList.contains('menu-opening');

      if (isDesktop || !isMenuOpen) {
        return;
      }

      this.instantlyHideDrawer();
    });
  }

  instantlyHideDrawer() {
    header?.classList.remove('menu-open');
    this.querySelector('.drawer__button')?.classList.remove('menu-is-open');
    super.instantlyHideDrawer();
  }

  toggleDrawer() {
    const isDrawerTransitioning = this.details.classList.contains(
      'drawer-transitioning'
    );

    /* if (isDrawerTransitioning) {
      return;
    } */


    const drawerButton = this.querySelector('.drawer__button');
    // if drawerButton has .menu-is-open class and if header has .menu-open class, drawer is open
    // so when drawerButton with .menu-is-open class is clicked, remove .menu-open class from header
    if (drawerButton.classList.contains('menu-is-open')) {
      header.classList.remove('menu-open');
      drawerButton.classList.remove('menu-is-open');
    } else {
      header.classList.add('menu-open');
      drawerButton.classList.add('menu-is-open');
    }


    // header.classList.toggle('menu-open');
    super.toggleDrawer();
  }

  toggleTrapFocus() {
    super.toggleTrapFocus(this.details);
  }

}

customElements.define('header-drawer', HeaderDrawer);

class DesktopDrawer extends MenuDrawer {
  constructor() {
    super();

    window.addEventListener('resize', e => {
      const isDesktop = window.innerWidth < tabletWidth;
      const isMenuOpen =
        this.details.classList.contains('menu-opening');

      if (!isDesktop || !isMenuOpen) {
        return;
      }

      this.instantlyHideDrawer();
    });
  }
}

customElements.define('desktop-drawer', DesktopDrawer);

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

// unpause all media
function unpauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'playVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"play"}', '*');
  });
  // document.querySelectorAll('video').forEach(video => video.play());

  document.querySelectorAll('video').forEach(video => {
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.then(_ => {
        // Automatic playback started!
        // Show playing UI.
        // video.play();
      })
      .catch(error => {
        // Auto-play was prevented
        // Show paused UI.
        // if paused, play
        video.play();
      });
    } else {
      // Show paused UI.
    }
  });


  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.play();
  });
}

const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

const fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: {
      'Content-Type': `application/${type}`,
      'Accept': `application/${type}`
    }
  };
};

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(button =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    const previousValue = this.input.value;

    event.target.name === 'increment'
      ? this.input.stepUp()
      : this.input.stepDown();

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;

    button.addEventListener('click', () => {
      const modal = document.querySelector(
        this.getAttribute('data-modal')
      );

      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.dialogHolder = this.querySelector('[role="dialog"]');
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', event => {
      if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
    });
    this.addEventListener('click', event => {
      if (event.target === this) this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    bodyScroll.lock(this.dialogHolder);
    this.setAttribute('open', '');
    trapFocus(this, this.dialogHolder);
    window.pauseAllMedia();
  }

  hide() {
    bodyScroll.unlock(this.dialogHolder);
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.unpauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

function isIOS() {
  return (
    /iPad|iPhone|iPod|iPad Simulator|iPhone Simulator|iPod Simulator/.test(
      navigator.platform
    ) ||
    (navigator.platform === 'MacIntel' &&
      navigator.maxTouchPoints > 1)
  );
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector(
          'template'
        ).content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );

      if (isIOS()) {
        deferredElement.controls = true;
      }

      deferredElement.play && deferredElement.play();

      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

/**
 * Additions
 */

class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.localizationInputElements = this.querySelectorAll(
      '[name="country_code"], [name="language_code"]'
    );

    this.localizationInputElements.forEach(inputElement => {
      inputElement.addEventListener('input', () => {
        this.form.submit();
      });
    });
  }
}

customElements.define('localization-form', LocalizationForm);

class AccordionDefault extends HTMLElement {
  constructor() {
    super();

    this.hideMultiple = this.hasAttribute('data-hide-multiple');
    this.summaryElements = this.querySelectorAll('summary');

    this.setInitialAccessibilityAttr();

    this.addEventListener('click', e => {
      const isBtn = e.target.classList.contains('js-btn');

      if (!isBtn) {
        return;
      }

      e.preventDefault();

      this.toggleDropdown(e.target);
      this.collapseInactiveItems();
    });

    this.addEventListener('keydown', e => {
      const isEscapeKey = e.key === 'Escape';

      if (!isEscapeKey) {
        return;
      }

      const closestOpenDetails = document.activeElement.closest(
        'details.is-active'
      );

      if (!closestOpenDetails) {
        return;
      }

      const btn = closestOpenDetails.querySelector('summary');

      this.toggleDropdown(btn);
      this.collapseInactiveItems();
    });
  }

  collapseInactiveItems() {
    if (!this.hideMultiple) return;
    const allSummaryElements = document.querySelectorAll(
      'accordion-default summary'
    );
    allSummaryElements.forEach(summary => {
      const accordionDefault = summary.closest('accordion-default');
      accordionDefault.toggleDropdown(summary, true);
    });
  }

  toggleDropdown(btn, forceClose) {
    const dropdown = btn.nextElementSibling;
    const isDropdownTransitioning = dropdown.classList.contains(
      'is-transitioning'
    );


    if (isDropdownTransitioning) {
      return;
    }

    const details = btn.parentElement;

    if (forceClose) {
      details.classList.remove('is-active');
      details.removeAttribute('open');
      btn.setAttribute('aria-expanded', false);
      dropdown.style.height = '0px';
      return;
    }

    details.classList.toggle('is-active');

    const isDetailsActive = details.classList.contains('is-active');

    btn.setAttribute('aria-expanded', isDetailsActive);

    if (isDetailsActive) {
      details.setAttribute('open', '');

      dropdown.style.height = `${dropdown.scrollHeight}px`;
    } else {
      dropdown.style.height = `${dropdown.scrollHeight}px`;

      setTimeout(() => {
        dropdown.style.height = '0px';
      }, 0);
    }

    dropdown.classList.add('is-transitioning');
    dropdown.addEventListener(
      'transitionend',
      handleHeightTransition
    );

    function handleHeightTransition(e) {
      const isHeight = e.propertyName === 'height';

      if (!isHeight) {
        return;
      }

      dropdown.removeEventListener(
        'transitionend',
        handleHeightTransition
      );
      dropdown.classList.remove('is-transitioning');

      if (isDetailsActive) {
        dropdown.style.height = 'auto';

        return;
      }

      details.removeAttribute('open');
      btn.focus();
    }
  }

  setInitialAccessibilityAttr() {
    this.summaryElements.forEach(summaryElement => {
      const detailsElement = summaryElement.parentElement;
      const dropdown = summaryElement.nextElementSibling;
      const isDetailsOpen = detailsElement.hasAttribute('open');

      summaryElement.setAttribute('role', 'button');
      summaryElement.setAttribute('aria-controls', dropdown.id);
      summaryElement.setAttribute('aria-expanded', isDetailsOpen);
    });
  }
}

customElements.define('accordion-default', AccordionDefault);

const nav = document.querySelector('.js-nav');

nav?.addEventListener('click', function (e) {
  const isHoverDisabled = matchMedia('(hover: none)').matches;
  const isLink = e.target.classList.contains('js-nav-link');

  if (!isHoverDisabled || !isLink) {
    return;
  }

  const link = e.target;
  const linkItem = link.parentElement;
  const linksList = linkItem.parentElement;
  const activeLinkItem = linksList.querySelector(
    '.js-nav-item.is-active'
  );
  const hasDropdown = linkItem.classList.contains('has-dropdown');

  if (activeLinkItem !== linkItem) {
    activeLinkItem?.classList.remove('is-active');
  }

  if (!hasDropdown) {
    return;
  }

  e.preventDefault();

  linkItem.classList.toggle('is-active');
});

document.addEventListener('click', function (e) {
  const targetActiveLinkItem = e.target.closest(
    '.js-nav-item.is-active'
  );

  if (targetActiveLinkItem) {
    return;
  }

  const activeLinkItems = document.querySelectorAll(
    '.js-nav-item.is-active'
  );

  if (activeLinkItems.length == 0) {
    return;
  }

  activeLinkItems.forEach(activeLinkItem => {
    activeLinkItem.classList.remove('is-active');
  });
});

let navItems = document.querySelectorAll(
  '.js-nav-item.has-dropdown:not(.default-dropdown)'
);

window.addEventListener('shopify:section:load', function () {
  navItems = document.querySelectorAll(
    '.js-nav-item.has-dropdown:not(.default-dropdown)'
  );
});

['DOMContentLoaded', 'resize'].forEach(eventType => {
  window.addEventListener(eventType, () => {
    navItems = document.querySelectorAll(
      '.js-nav-item.has-dropdown:not(.default-dropdown)'
    );
    navItems.forEach(navItem => {
      const dropdown = navItem.querySelector('.js-dropdown');

      if (!dropdown) {
        return;
      }

      const { y, height } = navItem.getBoundingClientRect();
      const itemTop = y + height;
      const dropdownY = dropdown.getBoundingClientRect().y;
      const isSameOffset = itemTop === dropdownY;

      if (isSameOffset) {
        return;
      }

      const difference = Math.round(dropdownY - itemTop);

      navItem.style.setProperty('--after-height', `${difference}px`);
    });

    document.querySelectorAll('.header__nav-dropdown--mega-deep').forEach(dd => {
      if (dd.matches(':hover') || dd.contains(document.activeElement)) {
        measureMegaDeepDropdownMinHeight(dd);
      }
    });
  });
});

/**
 * Desktop mega nav (fixed dropdown): keep the menu open while the pointer moves
 * through the gap between the top-level link and the fixed panel, or within the
 * dropdown, by mirroring :hover with a short-lived class (hover-capable viewports only).
 */
const JSC_NAV_DROPDOWN_HOVER = 'jsc-nav-dropdown-hover';
const NAV_DESKTOP_HOVER_HOLD_MS = 200;

function initDesktopNavDropdownHoverHold() {
  if (matchMedia('(hover: none)').matches) {
    return;
  }

  const isDesktopNav = () => window.innerWidth >= tabletWidth;

  const clearHoverClassEverywhere = () => {
    document
      .querySelectorAll(`.header__nav-item.${JSC_NAV_DROPDOWN_HOVER}`)
      .forEach(el => el.classList.remove(JSC_NAV_DROPDOWN_HOVER));
  };

  const bindNavItem = navItem => {
    if (navItem.dataset.jscNavHoverHold || navItem.classList.contains('default-dropdown')) {
      return;
    }

    const dropdown = navItem.querySelector('.header__nav-dropdown.js-dropdown');
    if (!dropdown) {
      return;
    }

    navItem.dataset.jscNavHoverHold = 'true';

    let leaveTimer = null;

    const clearLeaveTimer = () => {
      if (leaveTimer != null) {
        clearTimeout(leaveTimer);
        leaveTimer = null;
      }
    };

    const armOpen = () => {
      if (!isDesktopNav()) {
        return;
      }
      clearLeaveTimer();
      navItem.classList.add(JSC_NAV_DROPDOWN_HOVER);
      if (dropdown.querySelector('.js-mega-promo-region')) {
        resetMegaDeepPromoToDefault(dropdown);
      }
    };

    const scheduleClose = () => {
      clearLeaveTimer();
      leaveTimer = window.setTimeout(() => {
        navItem.classList.remove(JSC_NAV_DROPDOWN_HOVER);
        leaveTimer = null;
      }, NAV_DESKTOP_HOVER_HOLD_MS);
    };

    const pointerStillInZone = relatedTarget => {
      if (!(relatedTarget instanceof Node)) {
        return false;
      }
      return navItem.contains(relatedTarget) || dropdown.contains(relatedTarget);
    };

    navItem.addEventListener('pointerenter', armOpen);
    dropdown.addEventListener('pointerenter', armOpen);

    navItem.addEventListener('pointerleave', e => {
      if (pointerStillInZone(e.relatedTarget)) {
        return;
      }
      scheduleClose();
    });

    dropdown.addEventListener('pointerleave', e => {
      if (pointerStillInZone(e.relatedTarget)) {
        return;
      }
      scheduleClose();
    });
  };

  const refresh = () => {
    if (!isDesktopNav()) {
      clearHoverClassEverywhere();
      return;
    }

    document
      .querySelectorAll('.header__nav-item.has-dropdown:not(.default-dropdown)')
      .forEach(bindNavItem);
  };

  refresh();
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('resize', refresh);
}

initDesktopNavDropdownHoverHold();

const JSC_MEGA_L2_ACTIVE = 'jsc-mega-l2-active';

/**
 * Mega-deep: L3 lives in `.js-mega-l3-region` (not in-flow under each L2), so min-height
 * keeps the dropdown background tall enough for the visible L3 panel.
 */
function measureMegaDeepDropdownMinHeight(dropdown) {
  if (matchMedia('(hover: none)').matches) {
    return;
  }

  dropdown.style.removeProperty('min-height');
  void dropdown.offsetHeight;

  let openItem = Array.from(
    dropdown.querySelectorAll('.header__nav-links-item.has-dropdown')
  ).find(
    el =>
      el.matches(':hover') ||
      el.classList.contains('jsc-mega-l2-active') ||
      el.contains(document.activeElement)
  );

  if (!openItem) {
    openItem = dropdown.querySelector(
      '.header__nav-links-item--mega-first-with-children.has-dropdown'
    );
  }

  const region = dropdown.querySelector('.js-mega-l3-region');
  let sublinks = region
    ? Array.from(region.querySelectorAll('.js-mega-l3-panel')).find(p => !p.hidden)
    : null;
  if (!sublinks && openItem) {
    sublinks = openItem.querySelector(':scope > .header__nav-sublinks');
  }
  if (!sublinks) {
    return;
  }

  const db = dropdown.getBoundingClientRect();
  const sb = sublinks.getBoundingClientRect();
  const needed = Math.ceil(sb.bottom - db.top);
  const natural = dropdown.offsetHeight;

  if (needed > natural) {
    dropdown.style.minHeight = `${needed}px`;
  }
}

function syncMegaDeepL3Panel(dropdown, l2IndexStr) {
  const region = dropdown.querySelector('.js-mega-l3-region');
  if (!region || l2IndexStr == null || l2IndexStr === '') {
    return;
  }
  const key = String(l2IndexStr).trim();
  region.querySelectorAll('.js-mega-l3-panel').forEach(panel => {
    const panelKey = (panel.getAttribute('data-mega-l2-index') || '').trim();
    const show = panelKey === key;
    panel.hidden = !show;
  });
}

function syncMegaDeepPromoLayout(dropdown) {
  const region = dropdown.querySelector('.js-mega-promo-region');
  if (!region) {
    return;
  }
  const visible = region.querySelector('.js-mega-promo-panel:not([hidden])');
  if (!visible) {
    return;
  }
  const isMulti = visible.classList.contains('header__nav-promo-banners--multi');
  dropdown.classList.toggle('header__nav-dropdown--promo-desktop-one-col', !isMulti);
  dropdown.classList.toggle('header__nav-dropdown--promo-desktop-two-col', isMulti);
}

function hideAllMegaPromoPanels(dropdown) {
  const region = dropdown.querySelector('.js-mega-promo-region');
  if (!region) {
    return;
  }
  region.querySelectorAll('.js-mega-promo-panel').forEach(panel => {
    panel.hidden = true;
  });
  dropdown.classList.remove(
    'header__nav-dropdown--promo-desktop-one-col',
    'header__nav-dropdown--promo-desktop-two-col'
  );
}

function syncMegaDeepPromoPanel(dropdown, l2IndexStr) {
  const region = dropdown.querySelector('.js-mega-promo-region');
  if (!region) {
    return;
  }
  const panels = region.querySelectorAll('.js-mega-promo-panel');
  if (!panels.length) {
    return;
  }
  const key = String(l2IndexStr ?? '').trim();
  let matched = Array.from(panels).find(
    panel => (panel.getAttribute('data-mega-l2-index') || '').trim() === key
  );
  if (!matched) {
    matched = region.querySelector('.js-mega-promo-panel[data-mega-promo-default]');
  }
  if (!matched) {
    hideAllMegaPromoPanels(dropdown);
    return;
  }
  panels.forEach(panel => {
    panel.hidden = panel !== matched;
  });
  syncMegaDeepPromoLayout(dropdown);
}

function resetMegaDeepPromoToDefault(dropdown) {
  const region = dropdown.querySelector('.js-mega-promo-region');
  if (!region) {
    return;
  }
  const initial = region.querySelector('.js-mega-promo-panel[data-mega-promo-initial]');
  const defaultPanel = region.querySelector(
    '.js-mega-promo-panel[data-mega-promo-default]'
  );
  if (!initial && !defaultPanel) {
    hideAllMegaPromoPanels(dropdown);
    return;
  }
  const target = initial || defaultPanel;
  const initialIdx = (target.getAttribute('data-mega-l2-index') || '').trim();
  syncMegaDeepPromoPanel(dropdown, initialIdx);
}

function resetMegaDeepL3ToDefault(dropdown) {
  const region = dropdown.querySelector('.js-mega-l3-region');
  if (!region) {
    return;
  }
  const initial = region.querySelector('.js-mega-l3-panel[data-mega-l3-initial]');
  const initialIdx = initial && (initial.getAttribute('data-mega-l2-index') || '').trim();
  if (!initial || initialIdx === '') {
    return;
  }
  syncMegaDeepL3Panel(dropdown, initialIdx);
}

function initMegaDeepDropdownBackgroundHeight() {
  document.querySelectorAll('.header__nav-dropdown--mega-deep').forEach(dropdown => {
    if (dropdown.dataset.megaDeepMinHeightInit) {
      return;
    }
    dropdown.dataset.megaDeepMinHeightInit = 'true';

    const scheduleMeasure = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => measureMegaDeepDropdownMinHeight(dropdown));
      });
    };

    dropdown.addEventListener('pointerover', e => {
      if (e.target instanceof Element && dropdown.contains(e.target)) {
        scheduleMeasure();
      }
    });

    const navItem = dropdown.closest('.header__nav-item.has-dropdown');
    if (navItem) {
      navItem.addEventListener('pointerenter', scheduleMeasure);
    }

    dropdown.addEventListener('focusin', e => {
      const li = e.target.closest?.('.js-mega-l2-item');
      const l2Idx = li && (li.getAttribute('data-mega-l2-index') || '').trim();
      if (li && dropdown.contains(li) && l2Idx !== '') {
        syncMegaDeepPromoPanel(dropdown, l2Idx);
        if (dropdown.querySelector('.js-mega-l3-region')) {
          syncMegaDeepL3Panel(dropdown, l2Idx);
        }
        if (li.classList.contains('has-dropdown')) {
          clearMegaDeepL2Active(dropdown);
          li.classList.add(JSC_MEGA_L2_ACTIVE);
        }
      }
      scheduleMeasure();
    });

    dropdown.addEventListener('mouseleave', () => {
      dropdown.style.removeProperty('min-height');
    });

    dropdown.addEventListener('focusout', e => {
      if (!dropdown.contains(e.relatedTarget)) {
        dropdown.style.removeProperty('min-height');
        resetMegaDeepL3ToDefault(dropdown);
        resetMegaDeepPromoToDefault(dropdown);
        clearMegaDeepL2Active(dropdown);
      }
    });
  });
}

initMegaDeepDropdownBackgroundHeight();

document.addEventListener('shopify:section:load', initMegaDeepDropdownBackgroundHeight);

/** Mega-deep: keep L3 open while pointer stays on the same L2 row after hovering label/chevron (jsc-mega-l2-active). */
function clearMegaDeepL2Active(dropdown) {
  dropdown
    .querySelectorAll(`.header__nav-links-item.has-dropdown.${JSC_MEGA_L2_ACTIVE}`)
    .forEach(el => {
      el.classList.remove(JSC_MEGA_L2_ACTIVE);
    });
}

function syncMegaDeepL2ActivePointer(dropdown, target) {
  if (!(target instanceof Element) || !dropdown.contains(target)) {
    clearMegaDeepL2Active(dropdown);
    return;
  }

  const active = dropdown.querySelector(
    `.header__nav-links-item.has-dropdown.${JSC_MEGA_L2_ACTIVE}`
  );

  /* Prefer L2 row hit-testing over L3 (L3 is a sibling column — avoid fighting row changes). */
  const li = target.closest('.js-mega-l2-item');

  if (li && dropdown.contains(li)) {
    const l2Idx = (li.getAttribute('data-mega-l2-index') || '').trim();
    if (l2Idx !== '') {
      if (active !== li) {
        clearMegaDeepL2Active(dropdown);
        if (li.classList.contains('has-dropdown')) {
          li.classList.add(JSC_MEGA_L2_ACTIVE);
        }
      }
      syncMegaDeepPromoPanel(dropdown, l2Idx);
      if (dropdown.querySelector('.js-mega-l3-region')) {
        syncMegaDeepL3Panel(dropdown, l2Idx);
      }
      return;
    }

    if (active === li) {
      return;
    }

    clearMegaDeepL2Active(dropdown);
    return;
  }

  const visiblePanel = target.closest('.js-mega-l3-panel');
  if (visiblePanel && dropdown.contains(visiblePanel) && !visiblePanel.hidden) {
    const idx = (visiblePanel.getAttribute('data-mega-l2-index') || '').trim();
    const row = idx
      ? dropdown.querySelector(
          `.js-mega-l2-item.has-dropdown[data-mega-l2-index="${idx}"]`
        )
      : null;
    if (row) {
      if (active !== row) {
        clearMegaDeepL2Active(dropdown);
        row.classList.add(JSC_MEGA_L2_ACTIVE);
      }
      syncMegaDeepL3Panel(dropdown, idx);
      syncMegaDeepPromoPanel(dropdown, idx);
    }
  }
}

function initMegaDeepL2StickyOpen() {
  document.querySelectorAll('.header__nav-dropdown.js-dropdown').forEach(dropdown => {
    if (!dropdown.querySelector('.js-mega-promo-region')) {
      return;
    }
    if (dropdown.dataset.jscMegaDeepStickyInit) {
      return;
    }
    dropdown.dataset.jscMegaDeepStickyInit = 'true';

    resetMegaDeepPromoToDefault(dropdown);

    dropdown.querySelectorAll('.js-mega-l2-item[data-mega-l2-index]').forEach(li => {
      const activate = () => {
        const ix = (li.getAttribute('data-mega-l2-index') || '').trim();
        if (ix === '') {
          return;
        }
        syncMegaDeepPromoPanel(dropdown, ix);
        if (dropdown.querySelector('.js-mega-l3-region')) {
          syncMegaDeepL3Panel(dropdown, ix);
        }
        if (li.classList.contains('has-dropdown')) {
          clearMegaDeepL2Active(dropdown);
          li.classList.add(JSC_MEGA_L2_ACTIVE);
        }
      };
      li.addEventListener('mouseenter', activate);
      li.addEventListener('focusin', activate);
    });

      dropdown.addEventListener('pointermove', e => {
        const raw = e.target;
        const el =
          raw instanceof Element
            ? raw
            : raw && raw.parentElement instanceof Element
              ? raw.parentElement
              : null;
        syncMegaDeepL2ActivePointer(dropdown, el);
      });

    dropdown.addEventListener('pointerleave', e => {
      const rel = e.relatedTarget;
      if (!(rel instanceof Node) || !dropdown.contains(rel)) {
        clearMegaDeepL2Active(dropdown);
        if (dropdown.querySelector('.js-mega-l3-region')) {
          resetMegaDeepL3ToDefault(dropdown);
        }
        resetMegaDeepPromoToDefault(dropdown);
      }
    });
  });
}

initMegaDeepL2StickyOpen();
document.addEventListener('shopify:section:load', initMegaDeepL2StickyOpen);

// Add is scrolled class for header when transparent and sticky are enabled

let hero =
  document.querySelector('.hero-banner') ||
  document.querySelector('.hero-banner-tabs') ||
  document.querySelector('main section');

window.addEventListener('shopify:section:load', function () {
  hero =
    document.querySelector('.hero-banner') ||
    document.querySelector('.hero-banner-tabs') ||
    document.querySelector('main section');
});

toggleHeaderIsScrolled();

windowDynamicEvents.forEach(eventType => {
  window.addEventListener(eventType, function () {
    toggleHeaderIsScrolled();
  });
});

function toggleHeaderIsScrolled() {
  if (!header || !hero) return;
  const isHeaderTransparent =
    header.classList.contains('is-transparent');
  const isHeaderSticky = header.classList.contains('is-sticky');

  if (!isHeaderTransparent || !isHeaderSticky) {
    return;
  }

  const { height, y } = hero.getBoundingClientRect();
  // const isHeroInViewport = y + height - header.clientHeight > 0;
  const isHeroInViewport = y > 0; // edited by JS

  isHeroInViewport
    ? header.classList.remove('is-scrolled')
    : header.classList.add('is-scrolled');
}

// Animations

const animationObserverOptions = {
  rootMargin: '-100px'
};

const animationObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      return;
    }

    entry.target.classList.add('animation-init');
    entry.target.addEventListener(
      'animationend',
      () => {
        entry.target.classList.add('animation-none');
      },
      {
        once: true
      }
    );
    animationObserver.unobserve(entry.target);
  });
}, animationObserverOptions);

observeAnimationElements();

window.addEventListener('shopify:section:load', () => {
  observeAnimationElements();
});

function observeAnimationElements() {
  const animationElements = document.querySelectorAll(
    '[class*="js-animation-"]'
  );

  animationElements.forEach(animationElement => {
    animationObserver.observe(animationElement);
  });
}

// DropdownInput

class DropdownInput extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.dropdown = null;
    this.buttons = null;
    this.detailsTemplate = this.querySelector(
      'template[data-name="details"]'
    );
    this.optionTemplate = this.querySelector(
      'template[data-name="option"]'
    );
    if (!this.select) return;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.select.classList.add('hidden');
    this.appendTemplate();
  }

  appendTemplate() {
    const detailsTemplate =
      this.detailsTemplate.content.firstElementChild.cloneNode(true);
    const optionTemplate = this.optionTemplate.content;
    const options = Array.from(this.select.options);
    if (options.length === 0) return;
    const selectedOption = options.find(option => option.selected);
    detailsTemplate.querySelector('[data-label]').textContent = selectedOption.label;


    options.forEach(option => {

      const html = optionTemplate.cloneNode(true);
      const button = html.querySelector('button');
      const li = html.querySelector('li');

      button.setAttribute('data-value', option.value);
      button.textContent = option.label;
      button.toggleAttribute('disabled', option.disabled);
      li.classList.toggle('is-active', option.selected);
      detailsTemplate.querySelector('[data-options]').append(html);
    });

    this.append(detailsTemplate);
    this.dropdown = this.querySelector('details');
    this.buttons = this.dropdown.querySelectorAll('button');
    this.setHandlers();
  }

  update() {
    this.dropdown = null;
    this.buttons = null;
    this.querySelector('details')?.remove();
    this.appendTemplate();
  }

  setHandlers() {
    this.querySelector('summary').addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.buttons.forEach((button, index) => {
      button.addEventListener('click', event =>
        this.onOptionSelect(event, index)
      );
    });
  }

  onOptionSelect(event, index) {
    event.preventDefault();
    Array.from(this.select.options).forEach(option =>
      option.removeAttribute('selected')
    );

    this.select.options[index].setAttribute('selected', 'selected');
    this.select.value = event.target.dataset.value;
    this.select.dispatchEvent(new Event('change', { bubbles: true }));
    this.querySelector('[data-label]').textContent =
      this.select.options[index].label;
    this.setSelectedOption(event.target);

    // when option is selected, update the dropdown
    this.update();

  }

  setSelectedOption(buttonOption) {
    const buttonEl = buttonOption;
    this.buttons.forEach(button => {
      button.parentElement.classList.remove('is-active');
    });
    buttonEl.parentElement.classList.add('is-active');
    this.select.dispatchEvent(new Event('change'));
    this.select.closest('form')?.dispatchEvent(new Event('input'));
    this.close(
      undefined,
      this.dropdown.querySelector('summary'),
      this.dropdown
    );
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    isOpen
      ? this.close(event, summaryElement, detailsElement)
      : this.open(summaryElement, detailsElement);
  }

  open(summaryElement, detailsElement) {
    setTimeout(() => {
      detailsElement.classList.add('is-open');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(detailsElement, summaryElement);
  }

  close(event, summaryElement, detailsElement) {
    if (event) {
      event.preventDefault();
    }

    detailsElement.classList.remove('is-open');
    removeTrapFocus(summaryElement);
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = time => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      elapsedTime < 300 // Increase for animation duration if necessary
        ? window.requestAnimationFrame(handleAnimation)
        : detailsElement.removeAttribute('open');
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('dropdown-input', DropdownInput);


class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.vertical_offset_for_trigger = window.innerHeight * 0.5;
    this.addEventListener('click', this.scrollToTop.bind(this));
  }

  scrollToTop() {
    window.scroll({
      top: 0,
      behavior: 'smooth'
    });
  }

  connectedCallback() {
    window.addEventListener('scroll', () => this.handleScroll(), {
      passive: true
    });
  }

  handleScroll() {
    const top = window.pageYOffset;
    if (top > this.vertical_offset_for_trigger) {
      this.classList.remove('hide');
    } else {
      this.classList.add('hide');
    }
  }
}

customElements.define('back-to-top', BackToTop);

/* constants */
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};
